const successStatus = [
  'active',
  'trialing',
  'scheduled',
  'completed',
  'past_due',
  'canceled',
];

export default function isSubscriptionSuccessful(status) {
  return successStatus.includes(status);
}
